import {useQuery} from "@tanstack/react-query";
import {BasicSearchType} from "../../../../../types/common/basic";
import {readErpAccountListApi} from "../../../../../api/correspondent/CorresspondentApi";

type Props = {
    SearchData: BasicSearchType;
};

/**
 * ERP 거래처 검색
 */
export const useReadErpAccountList = ({SearchData}: Props) => {
    const {data} = useQuery({
        queryKey: ["readErpAccountList", SearchData],
        queryFn: async () => await readErpAccountListApi(SearchData),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
